<!-- Toggle Button -->
<button 
  class="sidebar-toggle"
  type="button"
  (click)="toggle()"
  [attr.aria-expanded]="isOpen()"
  aria-label="Toggle menu"
>
  <i class="bi bi-list fs-4"></i>
</button>

<!-- Overlay -->
@if (isOpen()) {
  <div class="sidebar-overlay" (click)="close()"></div>
}

<!-- Sidebar -->
<aside class="sidebar" [class.sidebar-open]="isOpen()">
  <div class="sidebar-header">
    <div class="sidebar-header-row">
      @if (user()) {
        <div class="sidebar-user-welcome">
          <i class="bi bi-person-circle sidebar-user-icon" aria-hidden="true"></i>
          <div class="sidebar-user-text">
            <p class="sidebar-welcome-label mb-0">Benvenuto,</p>
            <p class="sidebar-user-name mb-0 text-truncate">{{ getFullName() }}</p>
          </div>
        </div>
      }
      <button
        type="button"
        class="btn-close sidebar-header-close"
        [class.btn-close-white]="false"
        (click)="close()"
        aria-label="Chiudi menu"
      ></button>
    </div>
  </div>

  <nav class="sidebar-nav">
    <ul class="nav flex-column">
      <li class="nav-item">
        <a 
          class="nav-link"
          routerLink="/landing-page"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="close()"
        >
          <i class="bi bi-house-door me-2"></i>
          Home
        </a>
      </li>
      <li class="nav-item">
        <a 
          class="nav-link"
          routerLink="/settings"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="close()"
        >
          <i class="bi bi-gear me-2"></i>
          Profilo e Sicurezza
        </a>
      </li>
      <li class="nav-item">
        <a 
          class="nav-link"
          routerLink="/active-sessions"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="close()"
        >
          <i class="bi bi-shield-check me-2"></i>
          Sessioni Attive
        </a>
      </li>
      @if (isAdmin()) {
        <li class="nav-item sidebar-nav-group">
          <button
            type="button"
            class="nav-link sidebar-nav-group-toggle"
            [class.active]="isAdminRouteActive()"
            [attr.aria-expanded]="adminMenuOpen()"
            aria-controls="sidebar-admin-submenu"
            (click)="toggleAdminMenu()"
          >
            <i class="bi bi-shield me-2"></i>
            <span class="sidebar-nav-group-label">Admin</span>
            <i
              class="bi sidebar-nav-chevron ms-auto"
              [class.bi-chevron-down]="adminMenuOpen()"
              [class.bi-chevron-right]="!adminMenuOpen()"
              aria-hidden="true"
            ></i>
          </button>
          @if (adminMenuOpen()) {
            <ul class="nav flex-column sidebar-submenu" id="sidebar-admin-submenu">
              <li class="nav-item">
                <a
                  class="nav-link sidebar-submenu-link"
                  routerLink="/amministrazione"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="close()"
                >
                  <i class="bi bi-people me-2"></i>
                  User
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link sidebar-submenu-link"
                  routerLink="/amministrazione/ruoli-mail"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="close()"
                >
                  <i class="bi bi-envelope me-2"></i>
                  Ruoli mail
                </a>
              </li>
            </ul>
          }
        </li>
      }
    </ul>
  </nav>

  <div class="sidebar-footer">
    <button 
      type="button" 
      class="btn btn-outline-danger w-100"
      (click)="logout()"
    >
      <i class="bi bi-box-arrow-right me-2"></i>
      Logout
    </button>
  </div>
</aside>
